import React, { useEffect } from 'react'
import Layout from '../../brands/components/Layout'
import AddNewPolicy from '../components/AddNewPolicyModal'
import { Dropdown } from 'react-bootstrap'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { getLeavePolicies } from '../api'
import './index.css'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { LeavesPolicy } from '../types/index'
import { setLeavePolicies } from '../slice/index'
import DelLeaveType from '../components/DelLeaveType'

const LeavePolicy: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const leavePoliciesState = useAppSelector(
        (state) => state.leavePolicies.leavePolicies
    )
    const [showModal, setShowModal] = React.useState<boolean>(false)
    const [leavePolicyDetails, setLeavePolicyDetails] = React.useState<
        LeavesPolicy[]
    >([])
    const [policyCase, setPolicyCase] = React.useState<string>('')
    const [toUpdatePolicyDetails, setToUpdatePolicyDetails] =
        React.useState<LeavesPolicy | null>(null)
    const [delmodal, setShowDelModal] = React.useState<boolean>(false)
    const [deleteLeavePolicyId, setDeleteLeavePolicyId] =
        React.useState<string>('')

    // Get Leave Policies first time
    useEffect(() => {
        const fetchData = async () => {
            const requestData = {}

            try {
                dispatch(SHOW_LOADER())
                const response = await getLeavePolicies(requestData)
                dispatch(setLeavePolicies(response.data.data))
                setLeavePolicyDetails(response.data.data)
            } catch (error) {
                console.error('Error fetching leave types:', error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }

        fetchData()
    }, [])

    useEffect(() => {
        setLeavePolicyDetails(leavePoliciesState)
    }, [leavePoliciesState])

    const handleAddNewPolicy = (caseType: string, policy?: any) => {
        if (policy) {
            setToUpdatePolicyDetails(policy)
        } else {
            setToUpdatePolicyDetails(null)
        }
        setPolicyCase(caseType)
        setShowModal(true)
    }

    const handleDeleteClick = (id: string) => {
        setDeleteLeavePolicyId(id)
        setShowDelModal(true)
    }

    return (
        <div>
            <AddNewPolicy
                show={showModal}
                onClose={setShowModal}
                policyCase={policyCase}
                toUpdatePolicyDetails={toUpdatePolicyDetails}
            />
            <DelLeaveType
                show={delmodal}
                onClose={setShowDelModal}
                deleteLeavePolicyId={deleteLeavePolicyId}
            />
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="d-flex justify-content-between">
                            <div>
                                <h4>Leave Policies</h4>
                            </div>
                            <div>
                                <div className="button-block ">
                                    <a
                                        className="button button-primary me-5"
                                        onClick={() =>
                                            navigate('/leave-policies/add-type')
                                        }
                                    >
                                        LEAVE TYPES
                                    </a>
                                    <a
                                        className="button button-outline"
                                        onClick={() =>
                                            handleAddNewPolicy('Add')
                                        }
                                    >
                                        ADD NEW POLICY
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-table leave-policy">
                        <table>
                            <thead>
                                <tr>
                                    <th>Policy Name</th>
                                    <th>Time Off Type</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {leavePolicyDetails.map(
                                    (policy: any, index: any) => (
                                        <React.Fragment key={index}>
                                            <tr>
                                                <td>
                                                    <a
                                                        className="link"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            navigate(
                                                                `/leave-policies/edit/${policy.id}`,
                                                                {
                                                                    state: {
                                                                        toUpdatePolicyDetails:
                                                                            policy,
                                                                    },
                                                                }
                                                            )
                                                        }
                                                    >
                                                        {policy.title}
                                                    </a>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                    <div className="dropdown-custom-link">
                                                        {' '}
                                                        <Dropdown>
                                                            <Dropdown.Toggle
                                                                variant="success"
                                                                id={`dropdown-basic-${index}`}
                                                            >
                                                                <Icon icon="mage:dots" />
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item
                                                                    onClick={() =>
                                                                        handleAddNewPolicy(
                                                                            'Edit',
                                                                            policy
                                                                        )
                                                                    }
                                                                >
                                                                    Edit
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    onClick={() =>
                                                                        handleDeleteClick(
                                                                            policy.id
                                                                        )
                                                                    }
                                                                >
                                                                    Delete
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </td>
                                            </tr>
                                            {policy.leavePolicyDetails
                                                .filter(
                                                    (detail: any) =>
                                                        detail.isUnlimited ||
                                                        detail.numberOfLeaves !==
                                                            0
                                                )
                                                .map(
                                                    (
                                                        detail: any,
                                                        detailIndex: any
                                                    ) => (
                                                        <tr key={detailIndex}>
                                                            <td></td>
                                                            <td>
                                                                {detail.isUnlimited
                                                                    ? 'Unlimited'
                                                                    : detail.numberOfLeaves}
                                                            </td>
                                                            <td>
                                                                {
                                                                    detail.leaveTypeTitle
                                                                }
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    )
                                                )}
                                        </React.Fragment>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                    <></>
                </div>
            </Layout>
        </div>
    )
}

export default LeavePolicy
